export const certificateMigrations = [
  {
    id: '044_journey_completion_certificates',
    sql: `
      CREATE TABLE journey_certificates (
        id UUID PRIMARY KEY,
        journey_id UUID NOT NULL UNIQUE REFERENCES journeys(id) ON DELETE CASCADE,
        document_encrypted TEXT NOT NULL,
        file_name TEXT NOT NULL,
        created_by UUID REFERENCES users(id) ON DELETE SET NULL,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        expires_at TIMESTAMPTZ NOT NULL
      );
      CREATE INDEX journey_certificates_expiry_idx ON journey_certificates (expires_at);

      ALTER TABLE user_notifications DROP CONSTRAINT IF EXISTS user_notifications_type_check;
      ALTER TABLE user_notifications ADD CONSTRAINT user_notifications_type_check CHECK (type IN (
        'engagement_request','engagement_decision','photo_request','photo_decision',
        'meeting_proposed','meeting_confirmed','meeting_cancelled','schedule_confirmed','call_ready',
        'support_appointment','support_updated','payment_reviewed','guardian_reviewed',
        'journey_certificate'
      ));
      INSERT INTO notification_settings (type) VALUES ('journey_certificate')
      ON CONFLICT (type) DO NOTHING;
    `,
  },
] as const;
